// The import form has two destinations. A .zip hands off to a background job and reports
// progress back into this modal, so it must submit to the modal frame. A .json imports inline
// and lands on the new template's editor, which has to escape the frame. Nothing but the chosen
// filename distinguishes them, so the target is set on change.
export default class extends HTMLElement {
  connectedCallback () {
    this.input = this.querySelector('input[type="file"]')

    this.input?.addEventListener('change', () => this.update())

    this.update()
  }

  update () {
    const form = this.closest('form')

    if (!form) return

    const name = this.input?.files?.[0]?.name || ''

    form.dataset.turboFrame = name.toLowerCase().endsWith('.zip') ? 'modal' : '_top'
  }
}
